// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"0ab4e5e4","6679":"1278a6d5"}[chunkId] + ".chunk.css";
};